import { useEffect, useState } from 'react'

export const MIN_SEARCH_CHARS = 2
const TOO_FEW_CHARS_MESSAGE = 'Please enter at least 2 characters'

export const useTooFewCharactersTyped = (
  searchInput: string,
  matchCount: number
): string => {
  const [errorMessage, setErrorMessage] = useState('')

  useEffect(() => {
    let inputTimer: NodeJS.Timeout
    const tooFewChars =
      searchInput.length > 0 && searchInput.length < MIN_SEARCH_CHARS

    const handleTooFewCharacters = () => {
      if (tooFewChars) {
        setErrorMessage(TOO_FEW_CHARS_MESSAGE)
      }
      clearTimeout(inputTimer)
    }

    if (tooFewChars) {
      inputTimer = setTimeout(handleTooFewCharacters, 1000)
    } else {
      if (errorMessage) {
        setErrorMessage('')
      }
    }

    return () => {
      clearTimeout(inputTimer)
    }
  }, [searchInput, errorMessage])

  useEffect(() => {
    if (matchCount > 0 && searchInput.length < MIN_SEARCH_CHARS) {
      setErrorMessage(TOO_FEW_CHARS_MESSAGE)
    }
  }, [searchInput, matchCount])

  return errorMessage
}
